module.exports = __webpack_public_path__ + "img/target001.b38bbb2d.png";